<p-dialog [(visible)]="display" class="device-details" appendTo="body" [style]="{'width': '90vw', 'height': '90vh'}" 
            styleClass="device-details-dialog" (onHide)="onHide()"  (onShow)="onShow()">
    <p-header>
        <span>Device Details: {{deviceDisplayName}}</span>
    </p-header>

    <info-sets #infosets [selectedDevice]="selectedDevice" [isMasterDevice]="isMasterDevice" scrollHeight="calc(80vh - 250px)"></info-sets>

    <p-footer>
        <button type="button" pButton icon="fa fa-times" (click)="hide()" label="Close"></button>
    </p-footer>

</p-dialog>
